import '../assets/NcEmptyContent-C-nruaFh.css';
import { openBlock, createElementBlock, renderSlot, createCommentVNode, toDisplayString, createTextVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcEmptyContent",
  props: {
    /**
     * A header message about an empty content shown
     * @example 'No comments'
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Desription of the empty content
     * @example 'No comments yet, start the conversation!'
     */
    description: {
      type: String,
      default: ""
    }
  }
};
const _hoisted_1 = {
  class: "empty-content",
  role: "note"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-content__icon",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  key: 0,
  class: "empty-content__name"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-content__description"
};
const _hoisted_5 = {
  key: 2,
  class: "empty-content__action"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    _ctx.$slots.icon ? (openBlock(), createElementBlock("div", _hoisted_2, [
      renderSlot(_ctx.$slots, "icon", {}, void 0, true)
    ])) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "name", {}, () => [
      $props.name !== "" ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString($props.name), 1)) : createCommentVNode("", true)
    ], true),
    $props.description !== "" || _ctx.$slots.description ? (openBlock(), createElementBlock("p", _hoisted_4, [
      renderSlot(_ctx.$slots, "description", {}, () => [
        createTextVNode(toDisplayString($props.description), 1)
      ], true)
    ])) : createCommentVNode("", true),
    _ctx.$slots.action ? (openBlock(), createElementBlock("div", _hoisted_5, [
      renderSlot(_ctx.$slots, "action", {}, void 0, true)
    ])) : createCommentVNode("", true)
  ]);
}
const NcEmptyContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3dc730de"]]);
export {
  NcEmptyContent as N
};
